<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content><p>Etes vous sur de vouloir supprimer cet élément ?</p></div>
<div mat-dialog-actions>
  <button type="button" mat-button (click)="confirm()">Oui</button>
  <button type="button" mat-button (click)="cancel()">Non</button>
</div>
